import { useQuery } from 'react-query';
import { fetchWebConfiguration } from '@sls-react/api/configuration';
import { minutes30inMS } from '../constants/times';
import useMobile from '@sls-react/hooks/useMobile';
import { useMemo } from 'react';

export function useConfiguration() {
  return useQuery('configuration', fetchWebConfiguration, {
    staleTime: minutes30inMS,
  });
}

export function useConfigurationProperty(property: 'ads' | 'gear_experts') {
  const mobile = useMobile();
  const { data: configuration } = useConfiguration();

  return useMemo(() => {
    if (!configuration) {
      return false;
    }

    if (mobile) {
      if (property === 'ads') {
        return configuration.ads_mobile;
      }

      if (property === 'gear_experts') {
        return configuration.gear_experts_modal_mobile;
      }
    } else {
      if (property === 'ads') {
        return configuration.ads_desktop;
      }

      if (property === 'gear_experts') {
        return configuration.gear_experts_modal_desktop;
      }
    }
  }, [mobile, configuration, property]);
}
